module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-hb.1e0133b1.png";